document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.products-sale-box .bfcm-product-code').forEach((codeRow) => {
    const copyBtn = codeRow.querySelector('.code-copy-btn');
    const codeValue = codeRow.querySelector('.code-value');

    if (!copyBtn || !codeValue) return;

    const defaultLabel = copyBtn.textContent.trim();

    copyBtn.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const code = codeValue.textContent.trim();
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
        copyBtn.textContent = 'Copied';
      } catch (error) {
        console.error('Copy failed:', error);
        return;
      }

      setTimeout(() => {
        copyBtn.textContent = defaultLabel;
      }, 3000);
    });
  });
});
